import React from 'react';
import { FormControl } from 'react-bootstrap';

import DateTimeFilter from './dateTimeTableColumnFilter';
import './dateTimeTableColumnFilter.css';

const dateTimeColumnFormatter = (column, colIndex, { sortElement, filterElement }, params) => {
  let value = params.value === undefined ? null : params.value;
  let onEnter = params.onEnter === undefined ? null : params.onEnter;
  let onChange = params.onChange;
  return <React.Fragment>
    {column.text}
    {sortElement}
    <DateTimeFilter onClick={e => e.stopPropagation()} onChange={onChange} value={value} onKeyPress={(target) => {
      if (target.charCode === 13 && onEnter !== null) {
        onEnter();
      }
    }}/>
  </React.Fragment>;
};

const textColumnFormatter = (column, colIndex, { sortElement, filterElement }, params) => {
  let value = params.value === undefined ? '' : params.value;
  let onEnter = params.onEnter === undefined ? null : params.onEnter;
  let onChange = params.onChange;
  return <React.Fragment>
    {column.text}
    {sortElement}
    <FormControl onClick={e => e.stopPropagation()} type="text" onChange={e => onChange(e.target.value)} value={value}
                 onKeyPress={(target) => {
                   if (target.charCode === 13 && onEnter !== null) {
                     onEnter();
                   }
                 }}/>
  </React.Fragment>;
};

const selectColumnFormatter = (column, colIndex, { sortElement, filterElement }, params) => {
  const { value = '' } = params;
  let filterValues = params.filterValues;
  let onChange = params.onChange;
  return <React.Fragment>
    {column.text}
    {sortElement}
    <FormControl componentClass="select" onClick={e => e.stopPropagation()} onChange={e => onChange(e.target.value)}>
      {Object.keys(filterValues).map((text, index) => 
        <option key={index} selected={value === filterValues[text]} value={filterValues[text]}>{text}</option>)}
    </FormControl>
  </React.Fragment>;
};

export const ColumnFormatters = {
  text: textColumnFormatter,
  datetime: dateTimeColumnFormatter,
  select: selectColumnFormatter
};



// WEBPACK FOOTER //
// ./src/components/tableColumnFilterFormatters.js